export function createDefaultSegment(geometry = [], segment = {}) {
  return {
    id: segment.id,
    azimuth: 0,
    pitch: 0,
    area: 0,
    height: 0,
    lines: Array(geometry.length).fill(''),
    setbacks: Array(geometry.length).fill(0),
    acAnnual: 0,
    acMonthly: Array(12).fill(0),
    poaMonthly: Array(12).fill(0),
    solarAccess: Array(13).fill(1),
    tsrf: Array(13).fill(1),
    tof: Array(13).fill(1),
    ...segment,
    geometry: segment.geometry || geometry
  };
}

export function createDefaultObstacle(obstacle = {}) {
  const isLine = obstacle.shape === 'Line';
  return {
    height: isLine ? 0 : 12,
    radius: isLine ? 0 : 5,
    setback: isLine ? 25 : 0,
    ...obstacle
  };
}

export function appendSegment(segments = [], segment) {
  const geometry = Array.isArray(segment?.geometry) ? segment.geometry : [];
  return [...segments, createDefaultSegment(geometry, segment || {})];
}

export function appendObstacle(obstacles = [], obstacle) {
  return [...obstacles, createDefaultObstacle(obstacle || {})];
}

export function appendTree(trees = [], tree) {
  return [...trees, tree];
}

export function appendAnnotation(annotations = [], annotation) {
  return [...annotations, annotation];
}

export function removeById(items = [], id) {
  return items.filter((item) => item?.id !== id);
}

export function removeSegment(state, id) {
  const segments = removeById(state.segments || [], id);
  const panels = (state.panels || []).filter((panel) => panel?.id !== id);
  return {
    ...state,
    segments,
    panels,
    selectedObjects: {
      ...(state.selectedObjects || {}),
      roofSegments: [],
      roofVertices: {},
      roofLines: {},
      fireSetbacks: {},
      panels: {}
    },
    selectedRoof: -1,
    selectedPanels: false
  };
}

export function removeObstacle(state, id) {
  return {
    ...state,
    obstacles: removeById(state.obstacles || [], id)
  };
}

export function removeTree(state, id) {
  return {
    ...state,
    trees: removeById(state.trees || [], id)
  };
}

export function removeAnnotation(state, id) {
  return {
    ...state,
    annotations: removeById(state.annotations || [], id)
  };
}

export function patchSegmentField(segments = [], index, patch = {}) {
  if (!Number.isInteger(index) || index < 0 || index >= segments.length) {
    return segments;
  }
  return segments.map((segment, segmentIndex) =>
    segmentIndex === index ? { ...segment, ...patch } : segment
  );
}

export function patchPanelsLayout(state, panels) {
  return {
    ...state,
    panels: Array.isArray(panels) ? panels : state.panels
  };
}

export function appendGeometry(state, kind, item) {
  switch (kind) {
    case 'segment':
      return { ...state, segments: appendSegment(state.segments || [], item) };
    case 'obstacle':
      return {
        ...state,
        obstacles: appendObstacle(state.obstacles || [], item)
      };
    case 'tree':
      return { ...state, trees: appendTree(state.trees || [], item) };
    case 'annotation':
      return {
        ...state,
        annotations: appendAnnotation(state.annotations || [], item)
      };
    default:
      return state;
  }
}

export function removeGeometry(state, kind, id) {
  switch (kind) {
    case 'segment':
      return removeSegment(state, id);
    case 'obstacle':
      return removeObstacle(state, id);
    case 'tree':
      return removeTree(state, id);
    case 'annotation':
      return removeAnnotation(state, id);
    default:
      return state;
  }
}
